import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router, NavigationExtras } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ConnMessageService } from '../_services/conn-message.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    private _router: Router,
    private _connMessageService: ConnMessageService,
    private _spinner: NgxSpinnerService,
    private _abd: AppBaseDataService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(error => {
        let doSkip = ''
        try {
          doSkip = request.headers.get('do-need-to-process-interceptor')
        } catch { }

        if (doSkip == 'skip') {
          return throwError(() => error);
        }
        
        if (error) {
          //console.log("ERROR-EXCEPTION-INTERCEPTOR", error)
          this._abd.hideSpinner()
  // // //// Error Msg If No Internet Connection
        //    if(navigator.onLine){
        //   this._connMessageService.showToastMessage("No Internet Connection");
        //  }
          // Note: don't toast on error.statusText === 'Internal Server Error' here — that's just
          // the standard HTTP reason phrase for any plain 500, including graceful "no data yet"
          // 500s (e.g. dashboard widgets on a brand-new account). Let the status-500 case below
          // decide, since it already knows to stay silent when the body has success: false.

          // status 0 also happens for CORS/aborted/timed-out requests while the internet is fine,
          // so only treat it as "no internet" when the browser itself reports offline.
          const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;
          if (isOffline) {
            this._connMessageService.showNoInternetToast();
            return throwError(() => error);
          }
          if (error.status === 0) {
            return throwError(() => error);
          }

          switch (error.status) {
            case 400:

              try {
                if (error.error.message && error.error.responseStatusCode === 926) {
                  this._connMessageService.showToastMessage("Default data can't be deleted!");
                  break;
                }
              }
              catch { }

              if (error.error.message) {
                this._connMessageService.showToastMessage(error.error.message);
                break;
              }

              if (error.error.errors) {
                const modalStateErrors = [];
                for (const key in error.error.errors) {
                  if (error.error.errors[key]) {
                    modalStateErrors.push(error.error.errors[key])
                  }
                }
                throw modalStateErrors.flat();
              } else if (typeof (error.error) === 'object') {
                //alert(error.statusText)
                this._connMessageService.showToastMessage(error.statusText);
              } else {
                this._connMessageService.showToastMessage(error.error);
                //alert(error.error)
              }

              break;
            case 401:
              //alert(error.statusText)
              //this._connMessageService.showToastMessage(error.statusText);
              break;
            case 404:
              this._connMessageService.showToastMessage(error.statusText)
              // this.router.navigateByUrl('pages/notfound');
              break;
            case 500:
              try {
                if (!error.error.success) {
                  //this._connMessageService.showToastMessage('No data found')
                  return
                }
              } catch { return }

              try {
                if (request?.body?.Name === 'GETUSERBYUSERNAME') {
                  localStorage.removeItem('user')
                  if (window.location.href.includes('/handheld'))
                    this._router.navigate(['handheld/signin'])
                  else
                    this._router.navigate(['pages/signin'])
                  return
                }
                return;
                this._connMessageService.showToastMessage(error.error.data.error.message)
                break;
              } catch { }

              const navigationExtras: NavigationExtras = { state: { error: error.error } }
              this._router.navigateByUrl('/server-error', navigationExtras);
              break;
            case 503:
              this._connMessageService.showToastMessage('HTTP Error 503. The service is unavailable.')
              this._router.navigate([""])
              break
            case 504:
              this._connMessageService.showToastMessage('HTTP Error 504. Something is wrong from server side.')
              break
            default:
              const rr = this._router.url
              if (rr !== 'pages/signin') {
                if (window.location.href.includes('/handheld'))
                  this._router.navigate(['handheld/signin'])
                else
                  // this._router.navigate(['pages/signin'])
                  console.log(error)
                  // this._connMessageService.showToastMessage('Service is temporarily unavailable. Please try again later.')
                  break;
              }
              //alert('fatel error')
              this._connMessageService.showToastMessage('Something went wrong, please make sure you are connected to internet');
              //console.log('DEFAULT-ERROR', error);
              break;
          }
        }
        return throwError(() => error);
      })
    )
  }
}
